export function messageEventHandler(videoRef, message) {
  if (message.origin === window.location.origin && message.data.event) {
    switch (message.data.event) {
      case 'play':
      case 'replay':
        videoRef.current?.play();
        break;
    }
  }
}

let messageHandler = null;

export function addPlayerMessageEventHandler(videoRef) {
  messageHandler = messageEventHandler.bind(null, videoRef);
  window.addEventListener('message', messageHandler);
}

export function removePlayerMessageEventHandler() {
  window.removeEventListener('message', messageHandler);
}
